import React from 'react';
import ReactDOM from 'react-dom/client';
import {Helmet} from "react-helmet";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Hurt a designer</title>
      <link rel="canonical" href="https://hurt.kotsky.me" />
      <link
        rel="icon"
        href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>😖</text></svg>" 
      />
      <meta property="og:title" content="Hurt a designer" />
      <meta property="og:description" content="The worst things you can say to a designer" />
    </Helmet>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
